import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DoneIcon from '@mui/icons-material/Done';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {useReduxReducer} from "../../../redux/store";
import { formatServerDateTime } from 'utils/formatserverdate';

interface PayAtAgencyButtonProps {
  bookingKey?: string;
  optionTime?: string;
}
const PayAtAgencyButton: React.FC<PayAtAgencyButtonProps> = ({ bookingKey, optionTime }) => {
  const {t} = useTranslation()
  const { aboutUs } = useReduxReducer(state => state.config)
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getFullAddress = () => {
    if (!aboutUs) return '';
    const { street, houseNumber, zip, city, country } = aboutUs;
    return `${street}${houseNumber ? ` ${houseNumber}` : ''}, ${zip} ${city}, ${country}`;
  };

  return (
    <>
      <Button
        variant='outlined'
        onClick={handleOpen}
        className="bg-primary-6000 text-primary-6000 hover:bg-primary-700"
      >
        {t("b2c.booking.payatagency")}
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle className="flex items-center gap-2">
          <LocationOnIcon color="primary" />
          {t("pdf.information")}
        </DialogTitle>
        <DialogContent>
          <div className="space-y-4 py-2">
            {optionTime && (
              <Alert severity="warning" className="mb-4">
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                    <div>
                      <strong>{t("flightbooking.ticketing_deadline")}:</strong>
                      <div className="text-lg font-semibold text-orange-700">
                        {formatServerDateTime(optionTime)}
                      </div>
                    </div>
                  </div>
                  <div className="text-sm text-gray-700 mt-2">
                    {t("b2c.booking.payatagency.optiontimewarn", "You should go to our office to complete the reservation until this time")}
                  </div>
                </div>
              </Alert>
            )}
            
            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="font-bold text-xl mb-3 text-gray-800">{aboutUs?.agencyName}</h3>
              
              <div className="space-y-2">
                <div className="flex items-start gap-2">
                  <LocationOnIcon className="text-gray-600 mt-1" fontSize="small" />
                  <p className="text-gray-700">{getFullAddress()}</p>
                </div>
                
                {aboutUs?.phone && (
                  <div className="flex items-center gap-2">
                    <span className="text-gray-600 font-medium">{t("generals.phone")}:</span>
                    <span className="text-gray-700">{aboutUs.phone}</span>
                  </div>
                )}
                
                {aboutUs?.email && (
                  <div className="flex items-center gap-2">
                    <span className="text-gray-600 font-medium">{t("generals.email")}:</span>
                    <span className="text-gray-700">{aboutUs.email}</span>
                  </div>
                )}
              </div>
            </div>
            
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained">
            {t("flights.close")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PayAtAgencyButton; 